module.exports = __webpack_public_path__ + "static/media/emirates-mall.4cdf5d49.jpeg";